import styled from 'styled-components';
import ChatSendMessage from './ChatSendMessage';
import { colorSchema } from 'utils/style';

export default styled(ChatSendMessage)`
  .chat-send-message {
    background-color: ${colorSchema('white')};
    border-top: 1px solid ${colorSchema('grey100')};
    border-radius: 8px;
    display: flex;

    &__button {
      align-items: center;
      background-color: ${colorSchema('white')};
      border: 0;
      border-radius: 0 0 8px 0;
      cursor: pointer;
      display: flex;
      justify-content: center;
      width: 48px;
      padding: 0;
      padding-right: 1.4rem;

      svg {
        fill: ${colorSchema('grey300')};
        height: 24px;
        width: 24px;
      }

      &:hover {
        svg {
          fill: ${colorSchema('primary')};
        }
      }

      &.inactive {
        background-color: ${colorSchema('grey300')};

        &:hover {
          cursor: default;
        }
      }
    }

    &__textarea {
      border: 0;
      border-radius: 0 0 0 8px;
      width: 100%;
      padding: 1.6rem;
      resize: none;

      &:focus {
        box-shadow: inset 0 0 0 0 ${colorSchema('white')};
        outline: white;
      }
    }
  }
`;
